$(document).ready(function() {

   
  $('div.sk-wa-container').floatingWhatsApp({
    phone: '919971616565',
    position: 'right',
    size: '54px',
    zIndex: 10000,
    message: 'Hi, I have a question about Sarang Kaur outfits I would like some help with.'
  });
  
  $(".Footer__Title.Heading.u-h6").each(function() { 
    if($(this).text() == 'About') {
            $(this).wrapInner("<a href='https://www.sarangkaur.com/pages/about'></a>");
    }
  });
  
});

  function skSyncCurrencyDropdowns() {
      $(".Header__Wrapper .mlvedadesk .pick_currency .nice-select li.option").on('click', function() {
          var currVal1 = $(this).text();
          $(".sk-mobile-sw1 .pick_currency .nice-select span.current").text(currVal1);
          $(".sk-mobile-sw1 .pick_currency .nice-select li.option").removeClass("selected");
      });

      $(".sk-mobile-sw1 .pick_currency .nice-select li.option").on('click', function() {
          var currVal2 = $(this).text();
          $(".Header__Wrapper .mlvedadesk .pick_currency .nice-select span.current").text(currVal2);
          $(".Header__Wrapper .mlvedadesk .pick_currency .nice-select li.option").removeClass("selected");
      });
  }

  $(window).on('load', function() {
      setTimeout( function(){
          skSyncCurrencyDropdowns();
      }  , 1600 );
  });